enum AppStatus {
    PREPARING = 'preparing',
    REVIEW = 'review',
    PUBLISHED = 'published',
    HIDDEN = 'hidden',
}

export default AppStatus